import { Injectable, signal, WritableSignal, Signal } from "@angular/core";

import { Book } from "@bitwarden/web-vault/app/models/data/blobby/book.data";
import { View as ViewEnum } from "@bitwarden/web-vault/app/models/enum/view.enum";

@Injectable({
  providedIn: "root",
})

/**@Sinan divide this service into  todayViewService, pastViewService and futureViewService */
export class ViewsService {
  private _view: WritableSignal<ViewEnum> = signal<ViewEnum>(ViewEnum.TODAY);
  private _account: WritableSignal<Book> = signal<Book>(null);

  currentView: Signal<ViewEnum> = this._view.asReadonly();

  set view(view: ViewEnum) {
    this._view.set(view);
  }

  get view(): ViewEnum {
    return this._view();
  }

  set account(account: Book) {
    this._account.set(account);
  }

  get account(): Book {
    return this._account();
  }
}
